// "Price for: 24 x 36 inches" — the window sizes a shopper can price the
// product cards at, as on the reference store's collection pages. The first entry
// is the default and matches PricingService.REFERENCE_WIDTH_IN / _HEIGHT_IN.
//
// A fixed list rather than free input: each size is computed once per category
// and fabric kind, and cached, so an open-ended size would let anyone fill the
// cache and the database pool with one-off quotes.
export interface PriceForSize {
  width: number;
  height: number;
}

export const PRICE_FOR_SIZES: PriceForSize[] = [
  { width: 24, height: 36 },
  { width: 36, height: 48 },
  { width: 48, height: 60 },
  { width: 60, height: 72 },
  { width: 72, height: 84 },
];

export const DEFAULT_PRICE_FOR_SIZE = PRICE_FOR_SIZES[0];

export function isPriceForSize(width: number, height: number): boolean {
  return PRICE_FOR_SIZES.some((s) => s.width === width && s.height === height);
}

export const priceForLabel = (s: PriceForSize) => `${s.width} x ${s.height} inches`;
